// ComplianceEventListModal.jsx
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { IAM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import Status from "../../../components/ui/Status";
import Loader from "../../../components/ui/Loader/Loader";
import DateService from "../../../services/DateService";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { DisplayListPagination } from "../../../components/TapUi";
import TapHelper from "../../../services/TapHelper";

const ComplianceEventListModal = ({ isOpen, selectedDate, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [meta, setMeta] = useState({});
    const [events, setEvents] = useState([]);
    const accessToken = useSelector(state => state.auth.access_token);

    useEffect(() => {
        if (isOpen && selectedDate) {
            fetchComplianceDetails();
        }
    }, [isOpen, selectedDate]);

    const fetchComplianceDetails = async (page = 1) => {
        setLoading(true);
        try {
            const headers = { 'Authorization': 'Bearer ' + accessToken };

            const params = {
                due_date_start: selectedDate,
                due_date_end: selectedDate,
                per_page: 20,
                page: page
            };
            const response = await api.server2Api.get(`${IAM_API_BASE_URL_2}/report/asset_consolidated`, {
                params, headers
            });

            const complianceData = response.data?.data || [];
            setEvents(complianceData);

            setMeta(
                TapHelper.pick(response.data, [
                    'from',
                    'to',
                    'total',
                    'last_page',
                    'per_page',
                    'current_page'
                ])
            );

        } catch (error) {
            toast.error('Failed to load Compliance details');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show d-block">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Asset Compliance Events for {DateService.dateFormat(selectedDate , 'DD MMM YYYY')}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <div className="modal-body">
                            {loading ? (
                                <div className="text-center py-3"><Loader /></div>
                            ) : (
                                <table className="table table-bordered table-sm align-middle bg-white mt-2 table-fixed">
                                    <thead className="align-middle table-secondary">
                                        <tr>
                                            <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                            <th scope="col" style={{ width: "25%" }}> Name</th>
                                            <th scope="col" style={{ width: "20%" }}>Asset</th>
                                            <th scope="col" style={{ width: "20%" }}>Site Name</th>
                                            <th scope="col" style={{ width: "15%" }} className='text-center'>Due Date</th>
                                            <th scope="col" style={{ width: "15%" }} className='text-center'>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {events.length > 0 ? (
                                            events.map((event, index) => (
                                                <tr key={event.id || index}>

                                                    <td className='text-center'>
                                                        {((meta.current_page - 1) * meta.per_page) + index + 1}
                                                    </td>
                                                    <td className="mb-1 fw-bold">

                                                        {event?.checksheet_name ? <Link to={`/asset/compliance/${event.asset_id}`} target="_blank">{event?.checksheet_name}</Link> : '-'}
                                                    </td>
                                                    <td>
                                                        {event.name || '-'}
                                                        {event.asset_code ? ` (${event.asset_code})` : ''}
                                                    </td>
                                                    <td>{event?.site || '-'}</td>
                                                    <td className='text-center'>
                                                        {event.display ? DateService.dateFormat(event.display) : "-"}

                                                    </td>
                                                    <td>
                                                        {event.status ? (
                                                            <Status color={event.status_color_code}>
                                                                {event.status_text}
                                                            </Status>
                                                        ) : "-"}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td className="text-center" colSpan={6}>No Record Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                            )}
                            {events.length > 0 && (
                                <DisplayListPagination
                                    meta={meta}
                                    onPageChange={(e) => fetchComplianceDetails(e.selected + 1)}
                                />
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComplianceEventListModal;